import { type RefObject, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ProductLink } from '#app/components/marketing/product-link.tsx'
import routes from '#routes/index.js'

function MobileTeaserVideo({
	reference,
}: {
	reference: RefObject<HTMLVideoElement>
}) {
	return (
		<video
			ref={reference}
			src="/videos/home-sapienstone-mobile.mp4"
			controls={false}
			loop
			muted
			autoPlay
			playsInline
			preload="auto"
			className="inset-0 z-0 h-screen w-full object-cover lg:hidden"
		/>
	)
}

function DesktopTeaserVideo({
	reference,
}: {
	reference: RefObject<HTMLVideoElement>
}) {
	return (
		<video
			ref={reference}
			src="/videos/home-sapienstone-desktop.mp4"
			controls={false}
			loop
			muted
			autoPlay
			playsInline
			className="inset-0 z-0 hidden h-screen w-full object-cover lg:block"
		/>
	)
}

export function TeaserVideoJumbo({
	isIntersectingContent,
}: {
	isIntersectingContent: boolean
}) {
	const { t } = useTranslation('common')
	const mobileReference = useRef<HTMLVideoElement>(null)
	const desktopReference = useRef<HTMLVideoElement>(null)

	useEffect(() => {
		if (isIntersectingContent) {
			mobileReference.current?.pause()
			desktopReference.current?.pause()
		} else {
			void mobileReference.current?.play()
			void desktopReference.current?.play()
		}
	}, [isIntersectingContent])

	return (
		<div className="relative h-full w-full">
			{/* Always render both videos to avoid SSR hydration mismatch. CSS handles visibility. */}
			<DesktopTeaserVideo reference={desktopReference} />
			<MobileTeaserVideo reference={mobileReference} />

			<ProductLink
				link={routes.public.products.list.route({})}
				children={t('actions.checkOurProduct')
					.split(' ')
					.map((item: string) => (
						<span key={item}>
							{item}
							<br />
						</span>
					))}
			/>
		</div>
	)
}
